import Agric from '../assets/icons/leaf.svg'
import Arabic from '../assets/icons/arabic.svg'
import Art from '../assets/icons/art.svg'
import Biology from '../assets/icons/biology.svg'
import Chemistry from '../assets/icons/chemistry.svg'
import CRS from '../assets/icons/crs.svg'
import Commerce from '../assets/icons/commerce.svg'
import Computer from '../assets/icons/computer.svg'
import Economics from '../assets/icons/economics.svg'
import French from '../assets/icons/french.svg'
import Geography from '../assets/icons/geography.svg'
import Government from '../assets/icons/government.svg'
import hausa from '../assets/icons/hausa.svg'
import history from '../assets/icons/history.svg'
import homeEconomics from '../assets/icons/homeEconomics.svg'
import igbo from '../assets/icons/igbo.svg'
import islamic from '../assets/icons/islamic.svg'
import litInEng from '../assets/icons/litInEng.svg'
import maths from '../assets/icons/maths.svg'
import music from '../assets/icons/music.svg'
import physicalHealth from '../assets/icons/physicalHealth.svg'
import physics from '../assets/icons/physics.svg'
import accounting from '../assets/icons/accounting.svg'
import english from '../assets/icons/english.svg'
import yoruba from '../assets/icons/yoruba.svg'




export const booksRecommendations = [
    {
        id: 1,
        name: 'Agriculture',
        icon: Agric,
        contents: [
            {
                title: '',
                lists: [
                    `Adeniyi, M. O. et al (1999) Countdown to Senior Secondary Certificate Examination Agricultural Science, Ibadan: Evans`,
                    `Akinsanmi, O. (2000) Junior Secondary Agricultural Science, Uk: Longman.`,
                    `Akinsanmi, O. (2000) Senior Secondary Agricultural Science, Uk: Longman.`,
                    `Anthonio, Q. B. O. (1999) General Agriculture for West Africa, London: George Allen`,
                    `Are, L. A. et al (2010) Comprehensive Certificate Agricultural Science for Senior Secondary Schools, University Press Plc.`,
                    `Egbuna, C. K. et al (2014) Extension Modern Agricultural Science for Senior Secondary Schools (2010), Extension Publication`,
                    `Emmanuel C. A. (2003) A Dictionary of Agriculture, Benue: Agitab Publisher Makurdi`,
                    `Falusi, A. O. and Adeleye, I. O. A (2000) Agricultural Science for Junior Secondary Schools Books 1- 3, Ibadan:  Onibonoje`,
                    `Komolafe, M. F., Adegbola, A. A., Are, L. A. and Ashaye, T. I. (2004) Agricultural Science for Senior Secondary Schools 1, 2 and 3, Ibadan:  University Press Ltd.`,
                    `Philips T. A. (1986) Agricultural Notebook, Lagos: Longman`,
                    `STAN (1999) Agricultural Science for Senior Secondary Schools, Lagos: Longman`,
                ]
            }
         ]
    },
    {
        id: 2,
        name: 'Arabic',
        icon: Arabic,
        contents: [
            {
                title: '1. COMPREHENSION, COMPOSITION AND TRANSLATION',
                lists: [
                    `1. بشير أحمد محيي الدين و المرضي مختار المرضي: المطالعة الواضحة. كنو: شركة طن لامى و أبنائه.`,
                    `2. سيد حمرة مالك: الإنشاء العربى المتوسط (للمدارس الثانوية) إبادن مطبعة الجامعة ب. ل. س. 2005م.`,
                    `3. عبد الفتاح صبرى و علي عمر بك: القراءة الرشيدة. الجزء 1 - 4 القاهرة: دار المعارف.`,
                    `4. عبد الله الطيب: سمير التلاميذ الجزء 1 - 2 الخرطوم: مكتب النشر.`,
                    `5. غرب ط. زاريا (1999م): كيف تكتب الإنشاء: كنو مطبعة جامعة بايرو.`,
                    `6. محمد الأول أبوبكر و الآخرون: العربية الميسرة الجديدة للمرحلة الثانوية. إبادن: دار سبكترم للطباعة و النشر.`,
                    `7. محمد بديع شريف و سليم حكيم و الحاج حسين آدمو: العربية الجديدة فى نيجيريا. الكتاب 1 - 3 إكيجا: لونغمان.`,
                    `8. Adekilekun, A. L. A.: Learning Arabic Language, Ilorin.`,
                    `9. Balogun, I. A. B. and Oseni Z. I. (1982) A Modern Arabic Course Book 1 Lagos: Islamic Publications Bureau.`,
                    `10. Haywood, J. A. and Nahmad, H. M. (1965), A New Arabic Grammar of the Written Language, London: Lund Humphries.`,
                    `11. Malik, S. H. A. (1982) A Guide to Arabic Composition, Books I & II, Lagos I.P.B.`,
                    `12. Arabic newspapers, magazines and journals.`,
                ]
            },
            {
                title: '2. GRAMMAR',
                lists: [
                    `1. على الجارم و مصطفى أمين: النحو الواضح لمدارس المرحلة الأولية. الجرء 1 - 3. القاهرة: دار المعارف.`,
                    `2. محمد أجروم الصنهاجى: متن الأجرومية. القاهرة.`,
                    `3. محمد محيي الدين عبد الحميد: التحفة السنية بشرح المقدمة الأجرومية. بيروت: دار الفكر.`,
                    `4. Haywood, J.A and Nahmad, H.M (1965), A New Arabic Grammar of the Written Language, London: Lund Humphries.`,
                ]
            },
            {
                title: '3. ARABIC LITERATURE',
                lists: [
                    `1- زكريا حسين: المأدبة الأدبية للطلاب العربية في إفريقيا أوتثى: دار النور 2004م NECO/WAEC`,
                    `2- زكريا حسين: الطبقة العليا: دار النور أوتثى 2006م NECO/WAEC`,
                    `3- مصطفى لطفي المنفلوطي: العبرات بيروت والقاهرة (2004) WAEC/NECO`,
                    `4- جميل عبد الله الكنوي: ادفع بالتي هي أحسن مكتبة الحكمة الإسلامية كنو (2013) NECO/WAEC`,
                    `5- أحمد الاسكندري والآخرون: المفصل في تاريخ الأدب العربي NECO/WAEC`,
                ]
            },
            {
                title: 'TRANSLITERATION OF THE ABOVE BOOKS',
                lists: [
                    `1- ZAKARIYAU I. OSENI: AL-MA’DUBAT AL-ADABIYYAH.`,
                    `2- ZAKARIYAU I. OSENI: AL-TABAQATAL-ULYA (THE UPPER CLASS)`,
                    `3- MUSTAPHA LUTFI AL-MANFALUTI: AL-ABARAT.`,
                    `4- JAMIL ABDULLAHI ALKANAWI: IDFA’A BIL LATI HIYA AHSAN.`,
                    `5- AHMAD AL-ASKANDARI WAL AKHARUN: ALMUFASSAL FI TARIKH AL-ADABUL ARABI.`,
                ]
            },
         ]
    },
    {
        id: 3,
        name: 'Art',
        icon: Art,
        contents: [
            {
                title: '',
                lists: [
                    `Banjoko I. (2000) Visual Arts made Easy: Textbook for Schools and Colleges, Lagos, Movic Publishing Company Ltd.`,
                    `Egonwa, O.D. (1991) African Art: A contemporary Source Book, Benin: Osasu Publishers.`,
                    `Eguilae, S.A. (1985) The Essential Ground work in Art and Design, Omotola Standard Press and Bookshop (Nig) Ltd.`,
                    `Erese, U. O. and Ogunsina E. D. (1989) Creative Arts and Crafts for J. S. S. Onibonoje Press.`,
                    `Nahab, S. J. (2003) Art of the Millennium for Senior Secondary Schools, Ehindero (Nig.) Ltd.`,
                    `Ogumor, E. (1993) Certificate Art for Junior Secondary Schools and Senior Secondary Schools, Ibadan: University Press Plc.`,
                    `Olaosebikan W. A. (1982) Cultural and Creative Arts, Evans`,
                    `Olurukooba, B. K. (1991) Art for Senior Secondary Schools, ABU`,
                    `Uzoagba I. N. (1982) Understanding Art in General Education, Onitsha; African Publish Ltd`,
                    `Wangboje, I. N. (1982) A Textbook on Art for Junior and Senior Secondary Schools, Evans Publishers`,
                ]
            },
         ]
    },
    {
        id: 4,
        name: 'Biology',
        icon: Biology,
        contents: [
            {
                title: '',
                lists: [
                    ` Ndu, F.O. C. Ndu, Abun A. and Aina J.O. (2001) Senior Secondary School Biology: Books 1 -3, Lagos: Longman`,
                    `Odunfa, S.A. (2001) Essential of Biology, Ibadan: Heinemann`,
                    `Ogunniyi M.B. Adebisi A.A. and Okojie J.A. (2000) Biology for Senior Secondary Schools: Books 1 ? 3, Macmillan`,
                    `Ramalingam, S.T. (2005) Modern Biology, SS Science Series. New Edition, AFP`,
                    `Stan. (2004) Biology for Senior Secondary Schools. Revised Edition, Ibadan: Heinemann`,
                    `Stone R.H. and Cozens, A.B.C. (1982) Biology for West African Schools. Longman`,
                    `Usua, E.J. (1997) Handbook of practical Biology 2nd Edition, University Press, Limited`,
                ]
            },
         ]
    },
    {
        id: 5,
        name: 'Chemistry',
        icon: Chemistry,
        contents: [
            {
                title: '',
                lists: [
                    `1. Ababio, O. Y.  (2009). New School Chemistry for Senior Secondary Schools (Fourth edition), Onitsha: Africana FIRST Publishers Limited.`,
                    `2. Bajah, S.T.; Teibo, B. O., Onwu, G.; and Obikwere, A. Book 1 (1999). Senior Secondary Chemistry, Books 2 and 3 (2000).  Lagos: Longman.`,
                    `3. Ojokuku, G. O. (2012). Understanding Chemistry for Schools and Colleges, (Revised Edition), Zaria: Press-On Chemresources.`,
                    `4. Odesina, I. A. (2008). Essential: Chemistry for Senior Secondary Schools, (2nd Edition), Lagos: Tonad Publishers Limited.`,
                    `5. Uche, I. O. Adenuga, I. J. and Iwuagwu, S. L. (2003). Countdown to WASSCE/SSCE, NECO, JME Chemistry, Ibadan: Evans.`
                ]
            },
         ]
    },
    {
        id: 6,
        name: 'Christian Religious Studies',
        icon: CRS,
        contents: [
            {
                title: '',
                lists: [
                    `Adetunji, P.G. et al (2000) Exam Focus Christian Religious Knowledge for WASSCE and SSCE Ibadan: University Press Plc.`,
                    `Adeyemo, I. O. et al (1998) Christian Religious Knowledge for Secondary Schools Books1 ? 3, Ibadan: Onibonoje`,
                    `Adeyinka, A. A. et al (1991) Christian Religious Knowledge for Senior Secondary Schools, Book 1 ? 3, Lagos: Longman.`,
                    `Adigwe, H.A et al (2004) Christian Religious Knowledge for Senior Secondary Schools. Onitsha. Africana Publishers.`,
                    `Aghaeghuna, E. O. N. (1988) Senior Secondary School Christian Religious Knowledge: Themes from Selected Epistles, Vol 1 ? III, Awka, Jet Publishers.`,
                    `Dopamu, A. et al (1990) Christian Religious Knowledge for Senior Secondary Schools Books 1 ? 3, Lagos: Nelson.`,
                    `Ilori, J. A. et al (1980) Christian Religious Knowledge for Senior Secondary Schools Books 1 ? 3, Ibadan: Evans.`,
                    `Izuchukwu, A.E. et al (1997) Round-Up for Senior Secondary Certificate Examination Christian Religious Knowledge: A Complete Guide. Lagos: Longman.`,
                    `Throckmorton, B.H, Jr. (ed) (1966) Gospel Parallels: A Synopsis of the First Three Gospels. New York; Thomas Nelson.`,
                    `THE BIBLE: Revised Standard Version, Stonechill Green: Bible Society Publishing House (1971).`,
                ]
            },
         ]
    },
    {
        id: 7,
        name: 'Commerce',
        icon: Commerce,
        contents: [
            {
                title: '',
                lists: [
                    `Anderson, D. J. (1978) Commerce for West Africa, London: Macmillan.`,
                    `Ahukannah, L. I. et al (1992)  Commerce for Secondary Schools Onitsha: Africana ? First Publishers.`,
                    `Asaolu, A. and Igwe, P. M. (2005) New Syllabus Commerce for Secondary Schools Books 1 ? 3 (Second Edition) Ibadan: Evans.`,
                    `Babatunde, A. H. (1999) Handbook on Commerce for Schools and Colleges, (First Edition), Global Publications.`,
                    `Eriki, P. O. (1998) Working with Computer, Benin: Bofic Publishers.`,
                    `French, C. S. (2000) Computer Science, (Fifth Edition), Britain: Ashford.`,
                    `Ibru, G. M. (2004)  Nigeria:  The Promise of Tourism, Lagos:  G.S.L. Publishing Limited.`,
                    `Igwe, P. M. et al (2004)  Countdown to WASSCE/SSCE/NECO/JME Commerce, Ibadan: Evans.`,
                    `James, A. F. et al (1996)  Management (Sixth Edition), New Delhi:  Prentice Hall).`,
                    `Nwachukwu, C. C. (1999)  Management Theory and Practice, Onitsha:  Africana ? First Publishers.`,
                    `Odedokun, M. O. et al (1999)  Commerce for Senior Secondary Schools, Books 1 ? 3, Lagos: Longman.`,
                    `Odoom, F. F. (1998)  Commerce for Senior Secondary Schools, Books 1 ? 3, Ibadan:  Onibonoje.`,
                    `Onifade, A. (2001)  Management:  Office Business Education, Abeokuta: KAPPCO.`,
                    `Onifade, A. (2002)  The Computer for Word Processing and Internet, Abeokuta:  KAPPCO.`,
                    `Onu, A. J. C. (2000)  Marketing Today, Abuja:  Precious Treasures Ltd.`,
                    `Pallister, J. and Isaacs, A. (eds) (2002)  A Dictionary of Business (Third Edition), Oxford: Oxford University Press.`,
                    `Ubaka, O. A., (2012), Commerce Simplifiedfor SSS 1 ? 3, WAEC, NECO, JAMB & NABTEB EXAMS, Garki, Abuja: Andyson Millennium Concepts Ltd.`,
                ]
            },
         ]
    },
    {
        id: 8,
        name: 'Computer Studies',
        icon: Computer,
        contents: [
            {
                title: '',
                lists: [
                    `A Textbook for Year 11 - Computer Studies Bibhya Sharma, Shaveen Singh & Vijay Singh, Publisher: Technology and Employment Skills Training Ministry of Education, Fiji.`,
                    `Addan Emmanuel (2013). My Computer for Senior Secondary Schools 1, 2, 3 with Practical Training CD. Valueplus Publication Limited.`,
                    `Adebisi, A. J. (2013). Fundamentals of Computer Studies, Nigeria: Expert Consults, Available on https://www.researchgate.net/publication/258339295_FUNDAMENTALS_OF_COMPUTE R_STUDIES`,
                    `Adedapo F. O. Mitchell A. S. and Agunbiade D. A. (Assessed on August 6, 2021): Online with Computer Senior Secondary 2; rasmedpublications.com`,
                    `Brookshear, J. G. (1991). Computer Science: An Overview. Benjamin-Cummings Publishing Co. Inc.`,
                    `Chiemeke Stella C., Souley Boukari, Olumide B. Longe (Assessed on August 6, 2021); Computer Studies for Senior Secondary Schools; University Press Plc., upssbookshop.com`,
                    `Doyle, S (1995). Computer Studies for You, USA: Nelson Thomas Ltd, 2nd Edition. Available at https://www.amazon.com/GCSC-Computer-Studies-You/dp/0748703810`,
                    `Driscoll, T. & Dolden R. (1998). Computer Studies and Information Technology (The Motivate Series), Nigeria: Macmillan Education, Available at https://amazon.com/ComputerStudies-Information-Technology-Motivate/dp/0333598342`,
                    `Henderson, P. (1987, February), Modern Introductory Computer Science. In Proceedings of the eighteen SIGCSE technical symposium on Computer Science education (pp. 183-190).`,
                    `HiiT@School (Assessed on August 6, 2021); Computer Studies for Senior Secondary Education; HiiT`,
                    `Ojo D. J. (2018). Senior Secondary School Certificate Examination on Data Processing. Past Questions and Answers (2014 - 2020). Published by TONAD Publishers Limited. (Theory, Objectives and Practical)`,
                    `Otuka J. O. E. Akande A. F. and Iginla S. I. (2019): New Computer Studies 1-3; LearnAfrica`,
                    `Senior School Certificate Examinations/National Examination Council (SSCE/NECO). Past Questions and Answers on Computer Studies (Theory/Objectives).`,
                    `Sloan, R. H., & Troy, P. (2008). CS 0.5: a better approach to introductory computer science`,
                    `Sloan, R. H., & Troy, P. (2008). CS 0.5: a better approach to introductory computer science for majors. ACM SIGCSE Bulletin, 40(1), 271-275.`
                ]
            },
         ]
    },
    {
        id: 9,
        name: 'Economics',
        icon: Economics,
        contents: [
            {
                title: '',
                lists: [
                    `Aderinto, A.A et al (1996) Economics: Exam Focus, Ibadan: University Press Plc.`,
                    `Black, J. (1997) Oxford Dictionary of Economics. Oxford: Oxford University Press`,
                    `Eyiyere, D.O. (1980) Economics Made Easy, Benin City, Quality Publishers Ltd.`,
                    `Fajana, F. et al (1999) Countdown to SSCE/JME Economics Ibadan: Evans`,
                    `Falodun, A.B. et al (1997) Round-up Economics, Lagos: Longman`,
                    `Kountsoyiannis, A. (1979) Modern Microeconomics, London: Macmillan`,
                    `Lipsey, R.G. (1997) An Introduction to Positive Economics, Oxford:  Oxford University Press.`,
                    `Samuelson, P and Nordhaus, W. (1989) Economics, Singapore: McGraw-Hill`,
                    `Udu E and Agu G.A. (2005) New System Economics: a Senior Secondary Course, Ibadan:  Africana FIRST Publishers Ltd.`,
                    `Wannacott and Wannacott (1979) Economics, New York: McGraw-Hill.`,
                    `Brownson-oton Richard (2010) What is Micro-Economics? Niky Printing and Publishing coy.`,
                    `Brownson-oton Richard (2010) What is Macro-Economics? Niky Printing and Publishing coy.`,
                ]
            },
         ]
    },
    {
        id: 10,
        name: 'French',
        icon: French,
        contents: [
            {
                title: 'A. i.Written Language',
                lists: [
                    `Ajiboye, T. (2014) Companion to French Grammar (4th Edition) : Ibadan: Cleavoketa Books.`,
                    `Ajiboye, T. (2012) Nouvel Horizon, Book 4, New Revised Edition, Ibadan: Bounty Press.`,
                    `Byrne and Churchill (1980) A Comprehensive French Grammar.`,
                    `Hatier (1980) Le Nouveau Bescherelle: L’Art de Conjuguer, Ibadan: Spectrum Book Ltd.`,
                    `Maice, G et Merlo, G : (1998): Grammaire progressive du français ( Niveau, Paris: Clé intermediaire) International.`,
                    `Mazauric,. C, et Sirejols, E(2006) : On y va! Book 3, Ibadan : Spectrun Books Ltd.`,
                    `Ojo, S. A.(2000) A Comprehensive Revision Handbook of French Grammar, Ibadan: Agoro Publishing Company.`,
                    `Any other relevant materials on French Grammar.`,
                ]
            },
            {
                title: 'A. ii. Oral',
                lists: [
                    `Ajiboye, T. (2010) An Introduction to Practice in Oral French, Ibadan: Bount Press.`,
                    `Leon, M. (1978) Initiation à la Prononciation du Français Standard.`,
                    `Any other materials that emphasise oral practice.`,
                ]
            },
            {
                title: 'B. Culture of Francophone Countries',
                lists: [
                    `Girod R and Grand-Clement, F. (1979) Comment vivent les Français, Paris: Hachette.`,
                    `Mbuko, L. (2000) French Essays on Culture and Civilisation for Schools and Colleges, Ibadan: Bounty Press.`,
                    `Any other relevant materials, e.g. French newspapers, magazines, journals, and documents on Francophone life.`
                ]
            },
            {
                title: 'C. Dictionary',
                lists: [
                    `Any good French/English or French dictionary.`,
                ]
            },
         ]
    },
    {
        id: 11,
        name: 'Geography',
        icon: Geography,
        contents: [
            {
                title: '',
                lists: [
                    `Adeleke, B.O. Areola .O. 2002 and Leong, G.C. Certificate Physical and Human Geography for Senior Secondary School (West African Edition), Ibadan: Oxford.`,
                    `Bradshaw, M. et al (2004) Contemporary World Regional Geography, New York: McGraw Hill.`,
                    `Bunet, R.B and Okunrotifa, P.O.(1999) General Geography in Diagrams for West Africa, China: Longman.`,
                    `Collins New Secondary Atlas, Macmillan.`,
                    `Fellman, D. et al (2005) Introduction to Geography (Seventh Edition) New York: McGraw Hill.`,
                    `Getis, A. et al (2004) Introduction to Geography (Ninth Edition) New York: McGraw Hill.`,
                    `Iloeje, N. P(1999) A New Geography of West Africa, Hong Kong: Longman.`,
                    `Iloeje, N.P(1982) A New Geography of Nigeria (New Education), Hong Kong:  London.`,
                    `Nimako, D.A. (2000) Map Reading of West Africa, Essex: Longman.`,
                    `Okunrotifa, P.O. and Michael S. (2000)  A Regional Geography of Africa (New Edition), Essex:  London.`,
                    `Udo, R.K(1970) Geographical Regions of Nigeria, London: Longman.`,
                    `Waugh, D. (1995) Geography an Integrated Approach (Second Edition), China: Nelson.`,
                    `Adegoke, M.A (2013),  A Comprehensive Text on Physical, Human and Regional Geography.`,
                ]
            },
         ]
    },
    {
        id: 12,
        name: 'Government',
        icon: Government,
        contents: [
            {
                title: '',
                lists: [
                    `Adigwe, F (1985) Essentials of Government for West Africa, Ibadan:  University Press Plc.`,
                    `Anifowose, R and Enemuo, F. C. (eds)(1999) Elements of Politics, Lagos;  Malthouse Press Limited.`,
                    `Appadorai, A. (1978) The Substance of Politics, London:  Oxford University Press.`,
                    `Ball, A. R. (1983) Modern Politics and Government, London:  Macmillan.`,
                    `Ofoegbu, R.  (1977)  Government for the Certificate Year, London: George Allen and Unwin.`,
                    `Olawale, J. B (1987) New Topics on Ordinary Level Government, Ilesha:  Jola Publishing.`,
                    `Oyediran, O. Nwosu, H., Takaya, B., Anifowoshe, R., Femi, B., Godwill, O. and Adigun, A. (1990) Government for Senior Secondary Schools, Books 1, 2 and 3, Ibadan:  Longman.`,
                    `Oyeneye, I., Onyenwenu, M. and Olusunde, B. E. (2000)  Round-Up Government for Senior Secondary School Certifcate Examination:  A Complete Guide, Ibadan:  Longman.`,
                    `Oyovbaire, S., Ogunna, A. E. C., Amucheazi, E. C., Coker, H. O. and Oshuntuyi, O. (2001) Countdown to Senior Secondary Certificate Examination:  Government, Ibadan: Evans.`,
                ]
            },
         ]
    },
    {
        id: 13,
        name: 'Hausa',
        icon: hausa,
        contents: [
            {
                title: 'ZAƁAƁƁUN  LITTATTAFAI',
                lists: [
                    `Nau’i Marubuci Littafi`,
                    `Zube: Bambale, M.B. Kome Nisan Dare Zaria: NNPC, 2009 WAEC AND NECO`,
                    `Waƙa: Haɗeja, M. Waƙoƙin Mu'azu Haɗeja Zaria: NNPC, 1980 WAEC AND NECO`,
                    `Wasan Kwaikwayo: Katsina, U.Ɗ. Kulɓa Na Ɓarna Zaria: NNPC, 2011 WAEC AND NECO`,
                    `Galadanci, M.K.M. (1976), Introduction to Hausa Grammar, Zaria: Longman.`,
                    `Junju, M.H. (1980), Rayayyen Nahawun Hausa, Zaria: NNPC.`,
                    `Muhammad, Y.M. (2005), Fassarar Hausa, Zaria: ABU Press.`,
                    `Sani, M.A.Z. (1999), Tsarin Sauti Da Nahawun Hausa, Ibadan: UP Plc.`,
                    `Sani, M.A.Z. et al (2000), Exam Focus: Hausa Language, Ibadan: UP Plc.`,
                    `Skinner, N. (1977), Grammar of Hausa, Zaria: NNPC.`,
                    `Yahaya, I.Y. et al (1992), Darussan Hausa 1 – 3, Ibadan: UP Plc Don manyan makarantun sakandare.`,
                  ]
            },
            {
                title: 'B. ADABI DA AL’ADU (LITERATURE AND CULTURE',
                lists: [
                    `Bichi, A.Y. (1979), Wa?o?in Bikin Aure, Lagos: Nelson.`,
                    `Dangambo, A. (1984), Rabe – Raben Adabin Baka da Muhimmancinsa Ga Rayuwar Hausawa, Kano: T.P.C.`,
                    `Gusau, S.M. (1991), Maka?a Da Mawa?an Hausa, Kaduna: Fisbas Media Service.`,
                    `Ibrahim, M.S. (1977), Kowa Ya Sha Ki?a, Zaria: Longman.`,
                    `Madauci, I. et al (1992), Hausa Customs, Zaria: ABU Press.`,
                    `Umar, M.B. (1976), ?anmaraya Jos Da Wa?o?insa, Ibadan: OUP.`,
                    `Umar, M.B. (1977), Wasannin Tashe, Zaria: NNPC.`,
                  ]
            },
            {
                title: 'C. ?AMUSAI (DICTIONARIES)',
                lists: [
                    `Bargery G.P. (1951), A Hausa – English Dictionary and English-Hausa Vocabulary London: OUP.`,
                    `Newman, R.M. (1997), An English-Hausa Dictionary, Ibadan: Longman.`,
                    `Newman and Newman (1977), Sabon ?amus Na Hausa Zuwa Turanci, Ibadan: UPL.`,
                    `Skinner, N. (1993), Kamus Na Turanci Da Hausa, Zaria: NNPC.`,
                    `CSNL: (2006), ?amusun Hausa Na Jami’ar Bayero ta Kano, Kano: CSNL.`,
                  ]
            },
         ]
    },
    {
        id: 14,
        name: 'History',
        icon: history,
        contents: [
            {
                title: '',
                lists: [
                    `Abba, A (2006): The Politics of Mallam Aminu Kano, Kaduna Vanguard and Publishers.`,
                    `Ayandele, A. E. et al (1986): The Making of Modern Africa, The Twentieth Century Vol2., Longman.`,
                    `Ajayi and Crowther (1971): History of West Africa Vol. I, London, Longman.`,
                    `Ajayi and Crowther (1974): History of West Africa Vol. II, London, Longman.`,
                    `Akinloye, S. A. (1976): Emergent African States: Topics in Twentieth Century African History, Longman.`,
                    `Akinyemi, A. B., Agbi, S. O and Otunbanjo, A. O. (eds) (1989): Nigeria since Independence: The First 25 years. (International Relations) Vol x, Heinemann. Ibadan.`,
                    `Anene J. C. and Brown, G (1966): African in the 19th and 20th centuries, Ibadan: University Press.`,
                    `Anene J. C. (1966): Southern Nigeria in Transition, 1885 – 1906, Cambridge: University Press.`,
                    `Anene, J. C and Brown, G (eds) (1972): African in the Nineteenth and Twentieth Centuries: A Handbook for Teachers and Students, Ibadan: University Press and Nelson.`,
                    `Ashiwaju A. I., Croder, M and Denzer, I. R. (eds) Tariki 25, Grassroots Leadership in Colonial West Africa, Vol. 7, London: Longman.`,
                    `Atanda, J. A. Ashiwaju, G and Abubakar, Y. (eds) (1989) Nigeria since Independence: The First Years: Religion Vol. i., Ibadan Heinemann.`,
                    `Barkindo, B. et al (1989): Africa and the Wider World, Vol. 1. Lagos: Longman.`,
                    `Barkindo, B. et al (1996): African and the Wider World, Vols. 2 and 3, Lagos: Longman.`,
                    `Boahen, A (1969) The Revolutionary years: Africa since 1800, Longman publishers.`,
                    `Boahen, A (1969): The Revolutionary years: West Africa since 1800, Longman Publishers.`,
                    `Sokoto Caliphate: History and Legacies, 1804 – 2004, vols. I and II, Kaduna: Arewa House.`,
                    `Celeman, J. S. (1986) Nigeria: Background to Nationalism, Benin: Broburg and Wistrom.`,
                    `Clerk, T. A. (1991): Right Honourable Gentleman: The Life and Times of Alhaji Sir Abubakar Tafawa Balewa, Zaria: Hudahuda Publishing Company.`,
                    `Cohen, D. I. and Daniel, J. (eds) (1981): Political Economy of Africa: Selected Readings, London, Longman.`,
                    `Crowther, M.West Africa:An introduction to its History, Longman,1977.`,
                    `Crowther, M. Nigeria: An introduction to its History, London:Longman,1979.`,
                    `Dike, K. O. (1956): Trade and Politics in the Niger Delta, London: Oxford University Press.`,
                    `Ekeh, P. P and Ashiwaju, G. (eds) (1989): Nigeria since Independence: The First 25 Years: Culture, Vol. VII, Ibadan: Heinemann.`,
                    `Falola, T. et. al (1989): History of Nigeria Vol. I, Lagos: Longman.`,
                    `Falola T. et. al (1989): History of Nigeria Vol. 2 and 3, Lagos: Longman.`,
                    `Gboyega, A., Abubakar, Y and Aliyu Y. (eds) (1989): Nigeria since Independence: The First 25 Years Public Administration, Vol. III, Ibadan: Heinemann.`,
                    `Hallet, R. (1975): Africa since 1875, Ibadan: Heinemann.`,
                    `Hopkins, A. G. (1973): An Economic History of West Africa, Longman.`,
                    `Ikime, O and Osoba, S. O. (eds) Tarikh: Independence Movement in Africa (Part I), Vol. 3, No. 4 London: Longman.`,
                    `Ikime, O and Osoba, S. O. (eds) Tarikh: Government in Pre-Colonial Africa, Vol. 4, No. 2 London, Longman.`,
                    `Ikime, O and Osoba, S. O. (eds) (undated): Peoples and Kingdoms of West Africa in the Pre-colonial Period, Vol. 5, No. 1 London: Longman.`,
                    `Ikime, O and Osoba, S. O. (eds) (undated) Tarikh: Europeans Conquest and African Resistance (Part 2), Vol. 4, London: Longman.`,
                    `Ikime, O (1977) The Fall of Nigeria: The British Conquest, London: Heinemann.`,
                    `Ikime, O (ed) (1974) Leadership in 19th Century Africa: Essays from Tarikh, London: Longman`,
                    `Ikime, O. (1968) Merchant Price of the Niger Delta, London: Heinemann.`,
                    `Ikime, O. (ed) (1980) Ground work of Nigerian History, Ibadan: Heinemann.`,
                    `Iseihei, E. (1983) A History of Nigeria, London: Longman.`,
                    `Jorre, J. D. (1972) The Nigeria Civil War, London: Hordder and Stoughton.`,
                    `Kani, A. M. and Gandi, K. (1990) A State and Society in the Sokoto Caliphate, Series I, Usman Danfodio University, Sokoto.`,
                    `Mahdi, A., Kwanashei, G. A and Yakubu M. (eds) (1994) Nigeria: The state of the Nation and the Way Forward, Kaduna: Arewa House.`,
                    `Martin, P. M and Omera, P. (1995) (eds) Africa (Third Edition), Bloomington: Indiana University Press.`,
                    `Mohammed, B. (1982) Africa and Non-alignment: A study in the Foreign Relations of New Nations, Kano: Triumph Publishers.`,
                    `Mohammed A. S. and Adamu, S.(eds) (2005) Nigeria and the Reform of the United Nations, Zaria: Hanwa.`,
                    `Nzula, A. T., Potekhin and Zusmanovich (1979) Forced Labour in Colonial Africa, London: Zed Press.`,
                    `Offiong, D. A. (1980) Imperialism and Dependency: Obstacles to Development, Enugu: Fourth Dimension Publishers.`,
                    `Ojigbo, O. (1982) Shehu Shagari: The Biography of Nigeria’s First Executive President, Yugoslavia MlandiskaKnjiga.`,
                    `Okafor, I. (1989) History for Senior Secondary Schools, Onitsha, Jet Publishers.`,
                    `Oliver, T. and Afmore, A. (1996) Africa since 1880 (Fourth Edition) New York: Cambridge University Press.`,
                    `Olusanya G. O. (1973) The Second World War and Politics in Nigeria, 1939 – 1953, Ibadan: Evans.`,
                    `Omar O. (1966) The Zulu Aftermath: A Nineteenth-Century Revolution in Bantu Africa, London: Longman.`,
                    `Omolewa, M. (1986) Certificate History of Nigeria, Lagos: Longman.`,
                    `Onoja, I. (1998) Peace-keeping and International Security in a Changing World, Jos: Mono Expressions.`,
                    `Onwubiko, K. (1983) School Certificate History of West Africa, Onitsha: African – First Publishers.`,
                    `Tamuno, T. N. and Atanda A. (eds) (1989) Nigeria since Independence: The First 25 Years. Vol. III, Ibadan: Heinemann.`,
                    `Tamuno, T. N. and Atanda J. A. M. (eds) (1989) Nigeria since Independence: The First 25 Years. (Government and Public Policy), Vol. IV, Ibadan: Heinemann.`,
                    `Tamuno, T. N. and Ukpabi, S. C. (eds) (1989) Nigeria since Independence: The First 25 Years (The Civil War years). Vol. IV, Ibadan: Heinemann.`,
                    `Thompson, L. A. (2000) History of South Africa, Yale: Yale University Press.`,
                    `Usman Y. B. (ed) (1979) Studies in the History of Sokoto Caliphate, New York: Third Press International.`,
                    `Usman Y. B. (ed) (1981) The Transformation of Katsina, 1400 – 1883, Zaria: Ahmadu Bello University Press.`,
                    `Usman Y. B. (ed) and Alkali M. N. (1983) Studies in the History of Pre-Colonial Borno, Zaria: NNPC.`,
                    `Usman Y. B. and Kwanashei, G. A. (eds) Inside Nigeria History 1950-1970: Events: Issues and Sources (Presidential Panel on Nigeria: Since Independence), University of Ibadan.`,
                    `Usman Y. B. (ed) (1989): Nigeria since Independence: The First 25 Years: The Society Vol.I, Ibadan: Heinemann.`,
                    `Usman Y. B. (2002) Election Violence in Nigeria: The Terrible Experience, 1952 – 2002, Zaria: Abdullahi Smith Centre for Historical Research.`,
                    `Webster, J. B. and Ikime, O. (eds) Tarikh: Early African Christianity, Vol. 2. No. 1. London: Longman.`,
                    `Wilmot, P. F. (1980): Apartheid and African Liberation: The Grief and the Hope, Ife: University of Ife Press.`,
                    `Yakubu, A. M., Jumare, I and Saeed, A. G. (eds) (2005) Northern Nigeria: A century of Transformation, 1903 – 2003, Kaduna: Arewa House.`,
                    `Yakubu A. M. (2006) Emirs and Politicians: Reform, Reactions and Recrimination in Northern Nigeria, 1950 – 1966, Kaduna: Baraka Publishers.`,
                  ]
            },
         ]
    },
    {
        id: 15,
        name: 'Home Economics',
        icon: homeEconomics,
        contents: [
            {
                title: '',
                lists: [
                    `Anfani-Joe, M.E. and Ogunjide, L.O. (1993) Home Management for Senior Secondary School 1 ? 3, Ibadan:  University Press Plc.`,
                    `Anyakoha, E.U. and Eluwa, M. (1990) Home Management for Schools and Colleges, Onitsha: Africana FIRST Publishers.`,
                    `Anyakoha, E.U (2006) Home Economics for Junior Secondary Schools Books 1 ? 3, Onitsha Africana FIRST Publishers.`,
                    `Neil, A and Hesmondhalgh, Z. (1985) A Complete Revision Course for O?Level and GCE, Revised Home Economics, Charles Co. Ltd.`,
                    `Ogunjide, L.O., Egbuchulam, B., Eyisi, O. Anfani-Joe, M.E and Olusanya, J.O. (1993) Clothing and Textiles for Senior Secondary Schools 1 ? 3, Ibadan: University Press Plc.`,
                    `Olusanya, J.O., Eyis, O., Anfani-Joe, M.E., Ogunjide, L.O. and    Egbuchulam, B. (1990) Foods and Nutrition for Secondary Schools Books 1 ? 3, Ibadan: University Press Plc.`,
                    `Olusanya, J. O., Olojala, S. O., Bala, F and Eyisi, O. (2000) Exam Focus, Food and Nutrition for WASSCE and SSCE, Ibadan: University Press Plc.`,
                    `The Internet.`
                  ]
            },
         ]
    },
    {
        id: 16,
        name: 'Igbo',
        icon: igbo,
        contents: [
            {
                title: '',
                lists: [
                    `1. Emenanjo, E. N., Okolie, F. O. and Ekwe, B. U. (1995) Igbo maka Sin?? Sek?nd?r? Sukul I.`,
                    `2. Emenanjo, E. N., Dike, O. N., Agomo S. N and Ezeuko, R. O. (1999) Exam Focus maka WASSCE na UME, Ibadan: University Press Plc.`,
                    `3. Ezikeojiaku, P. A. Okebalama, C. N. Onweluzo, C. N and Ekwe B. U. (1991) Ule Igbo maka Sin?? Sek?nd?r?, Ibadan: University Press Plc.`,
                    `4. Ikekeonwu, C., Ezikeojiaku, P. A., Ubani, A. and Ugoji, J. (1999) Fon?l?ji na Grama Igbo, Ibadan: University Press Plc`,
                    `5. Nzeak?, J. U. T. (1972): Omenala Nd? Igbo, Ibadan: Longman.`,
                    `6. Okoye, O. F. S., Ofoegbu, N. F. and Ezidiegwu, B. L. (1997) ?gbara ?h?r? ?t?as?s? Igbo maka Sin?? Sek?nd?r?, Onitsha: Houston Publishers Ltd.`,
                    `7. Osuagwu, B. I. N. (1979): Nd? Igbo na Omenala Ha, Nigeria: Macmillan.`,
                    `8. Ubesie, T. U. (1978): ?d?nala Nd? Igbo, Ibadan: Oxford University Press.`,
                    `9. Umeh, I. O. A; Onyekaonwu, G. O. Nwadike, I. U. and Okeke I. O. (1992): ?t?as?s? na Ag?mag? Igbo nke Sin?? Sek?nd?r? Sukul, Ibadan: Evans.`,
                    `10. ?ba ? Mgbemena, A. (2006): Nt?ala Usoroas?s? Igbo, Ibadan: Gold Press Ltd.`,
                    `11. An?zie, C. C. (2003), Igbo Kwenu: Ak?k? na Omenala nd? Igbo Enugu: Computer Edge Publishers.`,
                    `12. ?f?mata, C. E. (2005): Ndezu ?t?as?s? Igbo. Enugu: Format Publishers (Nig) Ltd.`,
                    `13. Ofili, D. N., Anozie C.C. and Chukwu, A.O. (2012): Lingwistiiki Sayens? As?s? II. Enugu: Computer Edge Publishers.`
                  ]
            },
         ]
    },
    {
        id: 17,
        name: 'Islamic Studies',
        icon: islamic,
        contents: [
            {
                title: '',
                lists: [
                    `Abdul, M.O.A. (1976) Studies in Islam Series Book 3, Lagos: IPB`,
                    `Abdul, M.O.A. (1982) Studies in Islam Series Book 2, Lagos: IPB`,
                    `Abdul, M.O.A. (1988)The Classical Caliphate, Lagos: IPB`,
                    `Abdulrahman and Canham (n.d) The Ink of the Scholar, OUP`,
                    `Ali, A.Y. (1975) The Holy Qur?an Text: Translation and Commentary Leicester: The Islamic Foundation`,
                    `Ali, M.M. (n.d) The Religion of Islam, Lahore`,
                    `Doi, A. R. I. (1997) Shariah: The Islamic Law; Kuala Lumpur: Noordeen`,
                    `Hay Lal, M. (1982) The Life of Muhammad (SAW), Academic Press`,
                    `Lemu, A. (1992) Methodology of Primary Islamic Studies, Lagos: IPB`,
                    `Lemu, A. (1993) Islamic Studies for SSS, Book 1, Lagos: IPB`,
                    `Lemu, A. (1993) Islamic Studies for SSS, Books, Minna: IET`,
                    `Muhammad, S. Q. (2010) al-Burhanu fi tajwidil Qur?an Cairo: Shirkatul-Qudus`,
                    `Opeloye, M.O. (1996) A Dictionary of Peoples and Places in the Qur?an, Lagos: Academic Press`,
                    `Philips, A. A. B. (1997) Usool at-Tafseer, Kuala Lumpur: Noordeen`,
                    `Quadri, Y.A. et al (1990) Al-Iziyyah for the English Audience, Ijebu Ode: Shebiotiuom Publication`,
                    `Rahim, A. (1992) Islamic History, Lagos: IPB`,
                    `Sambo, M.B. et al (1984) Islamic Religious Knowledge for WASC Book 1, Lagos: IPB`,
                    `Sambo, M.B. et al (1984) Islamic Religious Knowledge for WASC Book 3, Lagos: IPB`,
                    `Trimingham, J.S. (1993) A History of Islam in West Africa, Oxford, OUP`,
                  ]
            },
         ]
    },
    {
        id: 18,
        name: 'Literature In English',
        icon: litInEng,
        contents: [
            {
                title: 'A LIST OF SELECTED AFRICAN AND NON-AFRICAN PLAYS, NOVELS AND POEMS',
                lists: [
                    `Drama:`,
                    `African:`,
                    `i. Frank Ogodo Ogbeche      :      Harvest of Corruption`,
                    `Non African:`,
                    `i. William Shakespeare          :      Othello`,
                    ``,
                    `Prose:`,
                    `African:`,
                    `i. Amma Darko                     :      Faceless`,
                    `Non-African:`,
                    `i. Richard Wright                   :      Native Son`,
                    ``,
                    `Poetry:`,
                    `African:`,
                    `i. Birago Diop                       :      Vanity`,
                    `ii. Gbemisola Adeoti              :      Ambush`,
                    `iii. Gabriel Okara                   :      Piano and Drums`,
                    `iv. Gbanabam Hallowell         :      The Dining Table`,
                    `v. Lenrie Peter                       :      The Panic of Growing Older`,
                    `vi. Kofi Awoonor                   :      The Anvil and the Hammer`,
                    `Non African:`,
                    `i. Alfred Tennyson                 :      Crossing the Bar`,
                    `ii. George Herbert                 :      The Pulley`,
                    `iii. William Blake                   :      The School Boy`,
                    `iv. William Morris                  :      The Proud King`,
                  ]
            },
            {
                title: '1. ANTHOLOGIES',
                lists: [
                    `Gbemisola, A. (2005)Naked Soles, Ibadan: Kraft`,
                    `Hayward, J. (ed.) (1968) The Penguin Book of English Verse, London: Penguin`,
                    `Johnson, R. et al (eds.) (1996) New Poetry from Africa, Ibadan: UP Plc`,
                    `Kermode, F. et al (1964) Oxford Anthology of English Literature,Vol. II, London: OUP`,
                    `Nwoga D. (ed.) (1967) West African Verse, London: Longman`,
                    `Senanu, K. E. and Vincent, T. (eds.) (1993) A Selection of African Poetry, Lagos: Longman`,
                    `Soyinka, W. (ed.) (1987) Poems of Black Africa, Ibadan: Heinemann`,
                  ]
            },
            {
                title: '2. CRITICAL TEXT',
                lists: [
                    `Abrams, M. H. (1981) A Glossary of Literary Terms, (4th Edition) New York, Holt Rinehalt and Winston`,
                    `Emeaba, O. E. (1982)A Dictionary of Literature, Aba: Inteks Press`,
                    `Murphy, M. J. (1972) Understanding Unseen, An Introduction to English Poetry and English Novel for Overseas Students, George Allen and Unwin Ltd.`,
                  ]
            },
         ]
    },
    {
        id: 19,
        name: 'Mathematics',
        icon: maths,
        contents: [
            {
                title: '',
                lists: [
                    `Adelodun A. A. (2000)   Distinction in  Mathematics:  Comprehensive  Revision Text, (3rd Edition) Ado ?Ekiti: FNPL.`,
                    `Anyebe, J. A. B. (1998)   Basic Mathematics for Senior Secondary Schools and Remedial Students in Higher Institutions, Lagos: Kenny Moore.`,
                    `Channon, J. B. Smith, A. M. (2001) New General Mathematics for West Africa SSS 1 to 3, Lagos: Longman.`,
                    `David ?Osuagwu, M. et al. (2000) New School Mathematics for Senior Secondary Schools, Onitsha:  Africana -   FIRST Publishers.`,
                    `Egbe. E et al (2000) Further Mathematics, Onitsha: Africana ? FIRST Publishers`,
                    `Ibude, S. O. et al.. (2003)  Algebra and Calculus for Schools and Colleges:  LINCEL Publishers.`,
                    `Tuttuh ? Adegun M. R. et al. (1997) Further Mathematics Project Books 1 to 3, Ibadan:  NPS Educational`,
                  ]
            },
         ]
    },
    {
        id: 20,
        name: 'Music',
        icon: music,
        contents: [
            {
                title: '',
                lists: [
                    `Akpabot, S. E. (1986). Foundation of Nigerian Traditional Music, Ibadan: Spectrum.`,
                    `Associated Board of the Royal School of Music (1958). Rudiments and Theory of Music, London.`,
                    `Cole, W. (1969). The Form of Music, London: The Associated Board of the Royal Schools of Music.`,
                    `Echezona, W. W. C. (1981). Nigerian Musical Instruments, Enugu: Apollo Publishing Ltd.`,
                    `Ekwueme, L. (1993). Choir Training and Choral Conducting for Africans, Lagos: Lenaus Advertising and Publishing Company.`,
                    `Holst, I. (1963). An ABC of Music, Oxford: Oxford University Press.`,
                    `Hosier, (1961).  Instruments of the Orchestra Oxford: Oxford University Press.`,
                    `Hunt, R. (1960). Elements of Music.`,
                    `Inanga, A. (1993). Music for Secondary Schools Vols. I and II, Ibadan: Spectrum.`,
                    `Kamien, R. (1990). Music: An Appreciation, London:  McGraw ? Hill Publishing Company.`,
                    `Kennedy, M. (1985). The Concise Oxford Dictionary of Music, (Third Edition), London: Oxford University Press.`,
                    `Kitson, C. H. (1978). Elementary Harmony Book 2, London: Oxford University Press.`,
                    `Kofoworola, Z. O. And Lateef, Y. (1987). Hausa performing Arts and Music, Lagos: Nigeria Magazine.`,
                    `Lovelock, W. (1953). A Concise History of Music, London: Bell and Hyman.`,
                    `Lovelock, W.(1996). The Rudiments of Music, London. G. Bell and sons Limited.`,
                    `Machlis, J. (1977). The Enjoyment of Music, New York: W. W. Norton.`,
                    `Mensah, A. A. (Undated) Folksongs for Schools, Accra.`,
                    `Morris, R. O. (1974). The Oxford Harmony, Vol. I, London: Oxford University Press.`,
                    `Nketia, J. H. (1974). African Music, New York: W. W. Norton Company.`,
                    `Palmer, K. (1965). Teach Yourself Music, London: The English University Press Limited.`,
                    `Reed, H. O. (1954). Basic  Music: A Basic Theory Text, New York:, N. Y. Mills Music Inc.`,
                    `Taylor, E. (1989). The Guide to Music Theory, London: The Associated Board of The Royal School of Music.`,
                    `Warburton, A. O. (1955). Graded Music Course for Schools, Books I ? III, London: Longman.`,
                  ]
            },
         ]
    },
    {
        id: 21,
        name: 'Physical and Health Education',
        icon: physicalHealth,
        contents: [
            {
                title: '',
                lists: [
                    `Afuekwe A. I. (2007). An Introductory Textbook of Physical Education for Secondary Schools and Colleges. Vol. 1. Sales Point (Nig.) Co.`,
                    `Afuekwe A. I. (2009). Health Topics in the New Curriculum of Physical and Health Education. Vol. 1. Seas Print (Nig.) Co.`,
                    `Nnabueze, U. C. (2002). Foundation of Health and Physical Education for Schools. Vol. II Enugu: Okotech Publishers.`,
                    `Ofadeji, A. A. (2013). Comprehensive Textbook on Physical and Health Education.`,
                    `Oworu, O. O. (2004). Fundamentals of Physical Education. Lucky Odoni (Nig.) Enterprises.`,
                    `Oyerinde, O. O., Dada, J. O. & Oloyede, R. O. (2021). A Textbook of Physical and Health Education for Secondary School in Contemporary Nigeria Education System. Fabonish Publisher, Positive Press, Ibadan. 4th Edition.`,
                    `Oyerinde, O. O., Dada, J. O. & Oloyede, R. O. (2021). All Times Health Education for Individual and College Student. Fabonish Publisher, Bayero University Press. 4th Edition.`,
                    `Puffa, H. A., Agbeko, W. W. & Amui. J. C. (2009). Foundations of Physical Education and Sports. Winneba, Ghana: Akwu`,
                  ]
            },
         ]
    },
    {
        id: 22,
        name: 'Physics',
        icon: physics,
        contents: [
            {
                title: '',
                lists: [
                    `Ike, E.E. (2014). Essential Principles of Physics, Jos ENIC Publishers.`,
                    `Ike, E.E. (2014). Numerical Problems and Solutions in Physics, Jos: ENIC Publishers.`,
                    `Nelson, M. (1977). Fundamentals of Physics, Great Britain: Hart Davis Education.`,
                    `Nelson, M. and Parker ? (1989). Advanced Level Physics, (Sixth Edition): Heinemann.`,
                    `Okeke, P.N. and Anyakoha, M.W. (2000). Senior Secondary School Physics, Lagos: Pacific Printers.`,
                    `Olumuyiwa, A. and Ogunkoya, O. O. (1992). Comprehensive Certificate Physics, Ibadan: University Press Plc.`,
                  ]
            },
         ]
    },
    {
        id: 23,
        name: 'Principles of Accounts',
        icon: accounting,
        contents: [
            {
                title: '',
                lists: [
                    `Abdullahi D. Z. (2014). Modern Financial Accounting, Husab Global Press Concept Ltd.`,
                    `Adeifa O. Ajileye, J. O and Oluwasanna, R. O (2001). Get your Financial Accounting Right.  Book One: Oyo: Tenlad Press International.`,
                    `Ajileye, J. O. and Adetifa O. (2001). Get your  Financial  Accounting Right, Book Two: Lagos: De Hadey Printing Services.`,
                    `Akinduko, A. O (2001).  Basic Accounting: Akure: Spetins.`,
                    `Awoyemi, E. O. (1989). A guide to Government Accounting and Internal Audit, Ibadan:  Onibonoje Press`,
                    `Dodge, R. (2002). Foundation of Business Accounting,  (Second Edition), Bershire: Chapman and Hall.`,
                    `Ekwere, A. B. (1997). Contemporary Accounting, Abuja:  Aflon Finance (Control and Management) Act 1959`,
                    `Ekwue K. C. (2010). Principles of Accounts, Book 1 & 2, Onitsha: Adson Publishing Company.`,
                    `Femi L. (2013). Simplified and Amplified Financial Accounting.`,
                    `Frankwood and Alan S. (2002). Frankwood?s Business Accounting, Prentice Hall International Edition.`,
                    `Hassan M. M. (2001). Government Accounting, Lagos: Malthouse Press Limited.`,
                    `Igben, R. O. (2004). Financial Accounting Made Simple  (Vol. I) Lagos: Roi Publishers.`,
                    `Longe, O. A. and  Kazeem,  R. A (2006). Essential  Financial Accounting for Senior Secondary Schools: Lagos:  Tonad Publishers Limited.`,
                    `Millichamp, A. H. (1989). Foundation Accounting:  An  Introduction manual for Accounting Students, London: DP Publications`,
                    `Okwoli, A. A. (1995). Financial Accounting, Zaria:   Tamaza Publishers.`,
                    `Oshisami, K. (1997). Government Accounting and  Financial Control:  Ibadan:  Spectrum.`,
                  ]
            },
         ]
    },
    {
        id: 24,
        name: 'Use of English',
        icon: english,
        contents: [
            {
                title: '',
                lists: [
                    `Attah, M. O. (2013). Practice in Spoken English for Intermediate and Advanced Learners, Maiduguri: University of Maiduguri Press.`,
                    `Bamgbose, A. (2002). English Lexis and Structure for Senior Secondary Schools and colleges (Revised Edition), Ibadan: Heinemann`,
                    `Banjo, A. et al (2004). New Oxford Secondary English Course Book Six for Senior Secondary Schools, Ibadan: UP Plc.`,
                    `Caesar, O. J. (2003). Essential Oral English for Schools and Colleges, Lagos: Tonad  Publishers Limited`,
                    `Daniel Jones (2011). Cambridge English Pronouncing Dictionary, Cambridge: Cambridge University Press`,
                    `Egbe, D. I (1996). Mastering English Usage and Communication Skills, Lagos: Tisons`,
                    `Elugbe, B. (2000). Oral English for Schools and Colleges, Ibadan: Heinemann`,
                    `Grant, N. J. H, Nnamonu, S. Jowitt, D. (1998). Senior English Project 3, (New Edition) Harlow: Longman`,
                    `Idowu, O. O, Sogbesan, T. S, Adofo, A. K. Burgess, D. F and Burgess, L. J. (1998). Round-up English: A Complete Guide, Lagos: Longman`,
                    `Idris, U. (2001). Oral English at Your Fingertips for Schools and Colleges, Lagos, M. Youngbrain Publishers`,
                    `Igiligi, E. C. and Ogenyi, S. O. (2010) Grammar and Composition in the G.S.M. Age, Enugu: Joe Hills Production Services`,
                    `Jauro, L. B. (2013). Oral English for Schools and Colleges: A teaching and Learning Approach, Yola: Paraclete Publishers.`,
                    `Nnamonu, S. and Jowitt, D. (1989). Common Errors in English, Lagos: Longman`,
                    `Obinna, M. F. (2001). University Matriculation Use of English,(Fourth Edition) Port Harcourt: Sunray Books Limited`,
                    `Ogunsanwo, O. Duruaku, A. B.C, Ezechukwu, J and Nwachukwu, U. I (2005). Countdown English Language, (Revised Edition), Ibadan: Evans`,
                    `Olatoye, S. (2006). The Silent Teacher, Ado-Ekiti: Segun and Sons Enterprises`,
                    `Oluikpe, B. O. A, Nnaemeka, B. A, Obah, T. Y, Otagburuagu, E. J. Onuigbo, S. and Ogbonna, E. A. (1998). Intensive English for Senior Secondary School 3, Onitsha: Africana ? FIRST Publisher.`,
                    `Tomori, S. H. O (2000). Objective Tests for School Certificate English: Practice in Lexis, Structure and Idiom (Reprinted Edition), Ibadan: Heinemann`,
                    `Ukwuegbu, C, Okoro, O., Idris, A. U., Okebukola, F. O. and Owokade, C. O. (2002). Catch-up English for SSCE/UME, Ibadan: Heinemann`,
                  ]
            },
         ]
    },
    {
        id: 25,
        name: 'Yoruba',
        icon: yoruba,
        contents: [
            {
                title: '',
                lists: [
                    `Abíọ́dún, Jíbọ́là (1995) Àròkọ àti Aáyan Ògbufọ̀, Lagos: MAJAB Publishers`,
                    `Adéwọlé, L. O. et al (2000) Exam Focus – Yorùbá language for WASSCE/ SSCE. Ìbàdàn: UP Plc.`,
                    `Awóbùlúyì, O. (1978) Essentials of Yorùbá Grammar, Ìbàdàn: UP Plc.`,
                    `Awóbùlúyì, O. (1990) Yorùbá Metalanguage (Èdè-Ìperí Yorùbá) Vol. II, Ìbàdàn: UP Plc.`,
                    `Awóbùlúyì, O. (2008) Èkọ́ Ìsẹ̀dá-Òrọ̀ Yorùbá, Akure: Montem Paperback.`,
                    `Awóbùlúyì, O. (2013) Èkọ́ Gírámà Èdè Yorùbá, Osogbo: Atman Ltd.`,
                    `Babalọlá, A. (ed.) (1991) Ìwé Ìmọ́dọ̀tun Yorùbá SSI – SSIII, Longman`,
                    `Bámgbóṣé,O.(ed.) (1984) Yorùbá Metalanguage (Èdè-Ìperí Yorùbá Vol. 1, Ìbàdàn:UP Plc.`,
                    `Bámgbóṣé, A. (1990) Fọnọ́lọ́jì áti Gírámà Yorùbá, Ìbàdàn`,
                    `Mustapha, O. (ed.) (1988) Èkọ́ – Èdè Yorùbá òde – òní SSI – SSIII, Macmillian`,
                    `Mustapha, O. (ed.) (1991) Èkọ́ – Èdè Yorùbá Titun SSI–SSIII, Yorùbá, Ìbà dàn: UP Plc.`,
                    `Ọdẹ́tókun, Adémọ́lá (et. al) (2005) Ìwé Ìgbáradì fún Ìdánwó Yorùbá, Ìbàdàn: Macmillan`,
                    `Owólabí, K. (1989) Ìjìnlẹ̀ Ìtúpalẹ̀ Èdè Yorùbá (1) Fónẹ́tíkì àti Fọnọ́lọ́jì, Ìbàdàn: Oníbọnòjé Press`,
                    `Owólabí, O, (et al) (1999) Countdown WASSCE/SSCE. NECO, JME (Ìwé Ìgbáradì fún Ìdánwó Àṣekágbá Yorùbá) Ìbàdàn: Evans`,
                    `Ọyàdèyi, O. (1998) Ìjìnlẹ̀ Fọnọ́lọ́jì áti Gírámà Èdè Yorùbá, Ìbàdàn: Heinemann`,
                  ]
            },
            {
                title: 'LITERAURE',
                lists: [
                    `All the prescribed texts are reflected as applicable on the syllabus under Topics/Contents/Notes column.`
                  ]
            },
            {
                title: 'CULTURE',
                lists: [
                    `Adéoyè, C. L. (1979) Àṣà àti Ìṣe Yorùbá, Ìbàdàn: OUP`,
                    "Adéoyè, C. L. (1985) Ìgbàgbọ́ àti Èsi`n Yorùbá, Ìbàdàn: Oníbọnọ̀jẹ́ press",
                    `Ládejé, T. A. et al (1986) Àkójọpọ̀ Ìwádìí Ìjìnlẹ̀ Àṣà Yorùbá, Ìbàdàn: Macmillian publishers`,
                  ]
            },
         ]
    },
]